/**
 * @module experience/change-plan-services
 * @copyright 1994-2017 T-Mobile US, Inc. All Rights Reserved.
 */ /** */

export const CPS_CONSTANTS = {
  CPS_MODULE: 'ChangePlanServicesModule',
  SUBMIT_BTN: 'submitButton',
  SUBMIT: 'submit',
  PRIMARY_CLASS: 'btn btn-primary',
  PRIMARY: 'Primary',
  CANCEL_BTN: 'cancelButton',
  SECONDARY_BTN: 'btn btn-secondary',
  SECONDARY: 'Secondary',
  CHANGE_PLAN_SERVICES: 'ChangePlanServicesModule',
  ADD: 'ADD',
  REMOVE: 'REMOVE',
  REMOVED: 'REMOVED',
  BACK_BTN: 'backButton',
  BACK: 'back',
  TODAYDATE: 'todayDate',
  PLAN: 'plan',
  PLANS: 'plans',
  SERVICE: 'Service',
  SERVICES: 'services',
  CANCELED: 'CANCELED',
  BILLING_DATE: 'billingDate',
  GRANDFATHERED: 'GRANDFATHERED',
  DROPDOWNINDEX: '0',
  CART_URL: '/cart',
  STARTTODAY: 'Today',
  CUSTOMDATE: 'Custom start date',
  ON_DEMAND_PASSES: 'on demand passes',
  ORDER_DETAILS: 'orderDetails',
  ORDER_DETAILS_FOR_ADDONS: 'orderDetailsForAddOns',
  TIME_ZONE: 'America/Los_Angeles',
  TIME_FORMAT: 'hh:mm A z',
  PST: 'PST',
  CUSTOM_MIN_RANGE: '1',
  CUSTOM_MAX_RANGE: '63',
  ORDER_STATUS_INPROCESS: 'INPROCESS',
  ORDER_STATUS_RECEIVED: 'RECEIVED',
  MANAGEADDON: 'MANAGEADDON',
  ONDEMAND: 'ONDEMAND',
  DATE_PIPE: 'en-US',
  DATE_FORMAT: 'MM-dd-yyyy',
  LINE_LANDING: '/line-landing',
  CARTID: 'CARTID',
  STACKED: 'Stacked',
  TRUE: 'true',
  ERROR: 'ERROR',
  ID: 'id',
  HEADER_TEXT: 'header-text',
  CANCELLED: 'CANCELLED',
  CPS: 'CPS',
  ERROR_101: '101',
  ERROR_100: '100',
  ORDER_TYPE: 'orderType',
  WARNING: 'WARNING',
};

export const ORDER_TYPES = ['MANAGEADDON', 'MANAGERATEPLAN', 'ACTIVATION', 'ADDALINE'];
export const CPS_ROUTES_CONSTANTS = {
  ACCOUNT_LANDING: '/account-landing',
};
